import ReportMarketMap from './ReportMarketMap';
export default ReportMarketMap;